/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {Checkbox, message} from 'antd'
import Select from 'react-select'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import $ from 'jquery'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import SearchableCombo from '../BaseComponent/searchableCombo'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import AutoComplete from '../BaseComponent/autocomplete'

class OrderDispatchIncomplete extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      wareHousesname: [],
      docType: [],
      errorForm: '',
      showTable: false,
      listWareHouse: [],
      preRecordInfo: {},
      urlQuery: '',
      providers: [],
      providerValue: '',
      selectedOption: [],
      wareType: [],
      report: [],
      fromDate: '',
      toDate: '',
      modalDelete: false,
      fromManual: '',
      toManual: '',
      printInfo: [],
      printFrom: '',
      printTo: '',
      buttonClicked: false,
      pageNumber: 1,
      pageSize: 10,
      countAll: 0,
      sortBy: 'providerId_desc',
      getSort: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'productId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تامین کننده',
          value: 'providerId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد سفارش',
          value: 'orderQuantity',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد در سند',
          value: 'docQuantity',
          sorted: false,
          direction: null,
          sortable: true
        }
      ],
      operators: [],
      roleBackOperators: [],
      operatorId: '',
      rollBackOperatorId: '',
      tablePageNumber: 1
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] =result[i].providerId +' - '+ result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getReport = (exportStatus) => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(exportStatus)
    http
      .get(`public/report/orderDispatch/incompatible`, {
        params: filter
      })
      .then((response) => {
        console.log(response.data)
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            tablePageNumber: this.state.pageNumber,
            tablePageSize: this.state.pageSize,
            report: response.data.object.result,
            printFrom: this.state.fromDate == '' ? ' - ' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
            printTo: this.state.toDate == '' ? ' - ' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
            buttonClicked: true,
            loading: false,
            lengthList: response.data.object.countAll
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
        this.setState({
          loading: false
        })
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }
  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    let planDateMin = this.state.fromDate
    let prodGrouping = document.getElementById('prodGrouping').value
    let providerId = this.state.providerId
    let planDateMax = this.state.toDate
    filter.export = exportStatus
    filter.prodGrouping = prodGrouping
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (planDateMin !== '') {
      filter.fromTime = planDateMin
    }

    if (planDateMax !== '') {
      filter.toTime = planDateMax
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    return filter
  }

  filter() {
    if (Object.keys(this.createFilter(false)).length - 3 === 0) {
      message.error('حداقل یک فیلتر وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    let filter = this.createFilter(true)

    http
      .get(`public/report/orderDispatch/incompatible`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          $('.showBaseTable,.print').fadeIn()

          this.setState({
            printInfo: response.data.object.result,
            lengthList: response.data.object.countAll,
            loading: false
          })
        } else {
          this.setState({
            printInfo: [],
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter(true)

    http
      .get(`public/report/orderDispatch/incompatible`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          let excelReport = this.state.excelReport

          this._export.save(excelReport)
        }
      })
  }

  handleChange = (selectedOption) => {
    this.setState({selectedOption})

    console.log(`Option selected:`, selectedOption)
  }

  render() {
    const {loading} = this.state
    let {pageNumber, pageSize} = this.state
    let name = cookie.load('name')
    let columns = ['ردیف', 'نام محصول', 'تامین کننده', 'تعداد سفارش', 'تعداد سفارش در سند']

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش اسناد ثبت شده در سفارش تامین کنندگان"
              headerColSpan={5}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={2}
              rightColSpan={1}
              centerColSpan={2}
              centerSection={''}
              rightSection={'تاریخ از ' + this.state.printFrom + ' تا ' + this.state.printTo}
              columns={columns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  <td>{item.providerId + ' - ' + item.providerName}</td>
                  <td>{item.orderQuantity}</td>
                  <td>{item.docQuantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            ref={(exporter) => {
              this._export = exporter
            }}
            dir="rtl"
            fileName="گزارش اسناد ثبت شده در سفارش تامین کنندگان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'productName'}
                field={'productName'}
                title={'نام محصول'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerId'}
                field={'providerId'}
                title={'شناسه تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'orderQuantity'}
                field={'orderQuantity'}
                title={'تعداد در سفارش'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'docQuantity'}
                field={'docQuantity'}
                title={'تعداد در سند'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>اسناد ثبت شده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  fromId="from"
                  toId="to"
                  defaulValue
                  force
                />

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <label>تامین کننده:</label>
                                    <Select
                                        value={this.state.selectedOption}
                                        onChange={this.handleChange}
                                        options={this.state.providers}
                                        isMulti={false}
                                        isClearable={true}
                                        id='providerId'
                                        placeholder=''
                                    /> */}
                </div>
                <div className="formComponent">
                  <label>برمبنای: </label>
                  <select className="form-control" id="prodGrouping">
                    <option value={false}>تامین کننده</option>
                    <option value={true}>محصول</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.report.map((item, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>{item.productName}</td>
                      <td>{item.providerId + ' - ' + item.providerName}</td>
                      <td>{item.orderQuantity}</td>
                      <td>{item.docQuantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.lengthList}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default OrderDispatchIncomplete
